import { AppLanguage } from '~/types/locale'
import { Labels, PortalProducts } from '~/analytics/types/analytics.type'

import AnalyticsEvents_V2 from '../analyticsGA4'

import {
  ChooseLanguageFrom,
  LandingPageEvents,
  MenuEvents,
  NavbarEvents,
  UserMenus,
} from './infrastructureEvents.types'

class InfrastructureAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.INFRASTRUCTURE)
  }

  public logChooseLanguage(language: AppLanguage, from: ChooseLanguageFrom): void {
    this.logEvent({
      event: NavbarEvents.CHOOSE_LANGUAGE,
      title: from,
      value: language,
    })
  }

  public logToggleMenu(media: 'desktop' | 'mobile', isOpen: boolean): void {
    this.logEvent({
      event: NavbarEvents.TOGGLE_MENU,
      status: isOpen ? Labels.OPEN : Labels.CLOSE,
    })
  }

  public logClickSeeMore(abLayout: 'A' | 'B'): void {
    this.logEvent({
      event: LandingPageEvents.CLICK_SEE_MORE,
      title: abLayout,
    })
  }

  public logToggleUserMenu(menu: UserMenus, showDropdown: boolean): void {
    this.logEvent({
      event: NavbarEvents.CLICK_USER_MENU,
      title: menu,
      status: showDropdown ? Labels.OPEN : Labels.CLOSE,
    })
  }

  public logViewMenuTooltip(item: string): void {
    this.logEvent({
      event: MenuEvents.VIEW_MENU_TOOLTIP,
      title: item,
      status: Labels.OPEN,
    })
  }
}

export default new InfrastructureAnalytics()
